module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "false",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-success icon-success"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Bank Account Updated")]), _vm._v(" "), (!_vm.isAdminView) ? _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n        Thanks for updating your bank account information. Your upcoming transactions have been automatically \n        updated to use your new default bank account. You can review these changes in the\n        "), _c('strong', [_c('a', {
    staticClass: "upcoming-transactions-link",
    attrs: {
      "href": "/#/upcoming-transactions"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToUpcomingTransactions($event)
      }
    }
  }, [_vm._v("Upcoming Transactions")])]), _vm._v("\n        section if you'd like to verify the updates.\n      ")]) : _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n        The user's bank account information has been successfully updated. Their upcoming transactions have been automatically \n        updated to use the new default bank account. You can review these changes in the\n        "), _c('strong', [_c('a', {
    staticClass: "upcoming-transactions-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToUpcomingTransactions($event)
      }
    }
  }, [_vm._v("Upcoming Transactions")])]), _vm._v("\n        section if you'd like to verify the updates.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v("OK")])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21ad9f9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/BankAccountChangedWarning.vue
// module id = 2115
// module chunks = 1